{
  "$id": "wealthlane://forms/employee-type",
  "$schema": "wealthlane://schemas/form-model",
  "domain": "../employee-type.domain.json",
  "properties": {
    "name": {
      "$ref": "module://employee-type#properties/name",
      "required": true
    },
    "description": {
      "$ref": "module://employee-type#properties/description"
    },
    "isTaxEnable": {
      "$ref": "module://employee-type#properties/isTaxEnable",
      "default": false
    }
  },
  "dataSource": {
    "submit": {
      "actionId": "SAVE_EMPLOYEE_TYPE",
      "refreshEntities": ["employee-type"],
      "invalidateQueries": ["getEmployeeTypesListWithPagination"]
    }
  },
  "modes": {
    "create": {
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "edit": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_EMPLOYEE_TYPE_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "lifecycle": {
        "submitBehavior": "close"
      }
    },
    "view": {
      "dataSource": {
        "fetch": {
          "actionId": "GET_EMPLOYEE_TYPE_FOR_EDIT",
          "params": {
            "id": "{params.id}"
          }
        }
      },
      "viewPresentation": "disabled-inputs"
    }
  }
}
